import type { StatusKey } from '@/types';
import type { ChantierStatut } from '@/services/chantiers';

/** Libellé + couleur de statut pour un chantier. */
export const CHANTIER_STATUT: Record<ChantierStatut, { label: string; status: StatusKey }> = {
  EN_PREPARATION: { label: 'En préparation', status: 'pending' },
  EN_COURS: { label: 'En cours', status: 'working' },
  SUSPENDU: { label: 'Suspendu', status: 'stuck' },
  ACHEVE: { label: 'Achevé', status: 'done' },
};

export const POSTE_LABEL: Record<string, string> = {
  MAIN_OEUVRE: "Main d'œuvre",
  MATERIAUX: 'Matériaux',
  MATERIEL: 'Matériel',
  SOUS_TRAITANCE: 'Sous-traitance',
  FRAIS_GENERAUX: 'Frais généraux',
  IMPREVU: 'Imprévu',
};
